import { Controller } from "@hotwired/stimulus"

// Filters Rock RMS attribute choices to match the selected entity type.
export default class extends Controller {
  static targets = ["personRadio", "familyGroupRadio", "attributeSelect", "attributeField"]
  static values = { options: Object }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasAttributeFieldTarget) return

    const options = this.optionsValue[this.selectedEntityType] || []
    const currentValue = this.attributeFieldTarget.value
    const selectedValue = this.optionExists(options, currentValue) ? String(currentValue) : ""

    this.replaceNativeOptions(options, selectedValue)
    this.refreshSingleSelect(options, selectedValue)
  }

  get selectedEntityType() {
    if (this.hasFamilyGroupRadioTarget && this.familyGroupRadioTarget.checked) return "family_group"
    if (this.hasPersonRadioTarget && this.personRadioTarget.checked) return "person"

    return "person"
  }

  optionExists(options, value) {
    return options.some((option) => String(option[1]) === String(value))
  }

  replaceNativeOptions(options, selectedValue) {
    this.attributeFieldTarget.innerHTML = ""
    this.attributeFieldTarget.append(new Option("", ""))

    options.forEach(([label, value]) => {
      const normalizedValue = String(value)
      const isSelected = normalizedValue === selectedValue
      this.attributeFieldTarget.append(new Option(label, normalizedValue, isSelected, isSelected))
    })
  }

  refreshSingleSelect(options, selectedValue) {
    if (!this.hasAttributeSelectTarget) return

    const singleSelectController = this.application.getControllerForElementAndIdentifier(
      this.attributeSelectTarget,
      "single-select"
    )

    if (!singleSelectController?.instance) return

    const choices = [
      { value: "", label: "", selected: selectedValue === "" },
      ...options.map(([label, value]) => {
        const normalizedValue = String(value)

        return {
          value: normalizedValue,
          label,
          selected: normalizedValue === selectedValue
        }
      })
    ]

    singleSelectController.instance.setChoices(choices, "value", "label", true)
  }
}
